import {createAsyncThunk, createSelector, createSlice} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";
import i18next from "i18next";
import AppUtil from "utilities/AppUtil";

const t = i18next.getFixedT();

const _urlPrefix = "/booking";

export const reduceAddBookingJob = createAsyncThunk(
    "booking/reduceAddBookingJob",
    async (params) => {
        // console.log(params);
        const result = await httpRequest({
            url: `${_urlPrefix}/add-booking-job`,
            data: snakecaseKeys(params),
            method: "POST",
            successMessage: t('toast.success.booking')
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);
export const fetchListBooking = createAsyncThunk(
    "booking/fetchListBooking",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/bookings`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);
export const fetchBookingDetail = createAsyncThunk(
    "booking/fetchBookingDetail",
    async (params) => {
        const { id } = params;
        const result = await httpRequest({
            url: `${_urlPrefix}/detail/${id}`,
            method: "GET"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);
export const reduceCancelBooking = createAsyncThunk(
    "booking/reduceCancelBooking",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/cancel`,
            method: "DELETE",
            data: snakecaseKeys(params),
            successMessage: "toast.update.200"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);
export const reduceUpdateBooking = createAsyncThunk(
    "booking/reduceUpdateBooking",
    async (params) => {
        const { id, ...rest } = params
        const result = await httpRequest({
            url: `${_urlPrefix}/update/${id}`,
            method: "PUT",
            data: snakecaseKeys(rest),
            successMessage: "toast.update.200"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);
export const autoBooking = createAsyncThunk(
    "booking/autoBooking",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/auto-booking`,
            method: "POST",
            params: snakecaseKeys(params),
            successMessage: "toast.success.booking"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);
export const fetchBookingBilling = createAsyncThunk(
    "booking/fetchBookingBilling",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/billing`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);
export const reduceExportBookingBilling = createAsyncThunk(
    "booking/reduceExportBookingBilling",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/export-for-billing`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.success.export_billing'
        });
        if (!result) {
            return;
        }
        AppUtil.downloadCSV(result, `booking-billing-${params.billingId}`);
        return result;
    }
);

export const fetchPayrollBooking = createAsyncThunk(
    "booking/fetchPayrollBooking",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/payroll`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);
export const exportPayrollBooking = createAsyncThunk(
    "booking/exportPayrollBooking",
    async (params) => {
        const { id } = params;
        const result = await httpRequest({
            url: `${_urlPrefix}/export-for-payroll/${id}`,
            method: "GET"
        });
        if (!result) {
            return;
        }
        return result;
    }
);
export const reduceUpdateWorkingTime = createAsyncThunk(
    "booking/reduceUpdateWorkingTime",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/working-time`,
            method: "PUT",
            data: snakecaseKeys(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceUpdateEndBooking = createAsyncThunk(
    "booking/reduceUpdateEndBooking",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/end`,
            method: "PUT",
            data: snakecaseKeys(params),
            successMessage: "toast.update.200"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchListTimesheet  = createAsyncThunk(
    "booking/fetchListTimesheet",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/get-time-sheet-table`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchTimesheetDetail = createAsyncThunk(
    "booking/fetchTimesheetDetail",
    async (params) => {
        const { id } = params;
        const result = await httpRequest({
            url: `${_urlPrefix}/get-time-sheet-detail/${id}`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchBookingCalendarByParticipants = createAsyncThunk(
    "booking/fetchBookingCalendarByParticipants",
    async (params) => {
      const result = await httpRequest({
        url: `${_urlPrefix}/get-bookings-follow-client`,
        method: "GET",
        params: AppUtil.toSnakeCaseKey(params)
      });
      if (!result) {
        return;
      }
      return result.data;
    }
  );

export const fetchSameScheduleBooking = createAsyncThunk(
    "booking/fetchSameScheduleBooking",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/add-booking-week`,
            method: "POST",
            data: AppUtil.toSnakeCaseKey(params),
            // successMessage: "toast.apply_same_schedule.200"
        });
        if (!result) {
            return;
          }
          return result.data;
        }
)

export const updateExtendEndTimeBooking = createAsyncThunk(
    "booking/updateExtendEndTimeBooking",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/admin-extend-time`,
            method: "PUT",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: "toast.update.200"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const approvalExpressInterest = createAsyncThunk(
    "booking/approvalExpressInterest",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/approval-express-interest`,
            method: "PUT",
            data: snakecaseKeys(params),
            successMessage: "toast.update.200"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const getBookingTask = createAsyncThunk(
    "booking/getBookingTask",
    async (params) => {
        const result = await httpRequest({
            url: `/booking-tasks/list`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchPageBookingByJob = createAsyncThunk(
    "booking/fetchPageBookingByJob",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/page-booking-by-job`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

const initialState = {
    timesheetList: [],
    timesheetDetail: [],
  };

const slice = createSlice({
    name: "booking",
    initialState: initialState,
    reducers: {

    },
    extraReducers: {
        [fetchListTimesheet.fulfilled]: (state, { payload }) => {
            if (payload) {
              state.timesheetList = payload.content;
            }
          },
          [fetchTimesheetDetail.fulfilled]: (state, { payload }) => {
            if (payload) {
              state.timesheetDetail = payload.content;
            }
          },
    }
});

export default slice.reducer;


export const getTimesheetList = createSelector(
    (state) => state.booking.timesheetList,
    (timesheetList) => timesheetList
);

export const getTimesheetDetail = createSelector(
    (state) => state.booking.timesheetDetail,
    (timesheetDetail) => timesheetDetail
);
